import React from "react";
import ResponsiveImage from "../ResponsiveImage/ResponsiveImage";
import { abbreviateName } from "../../util/circleHelper";
import ProfileIconCard from "../ProfileIconCard/ProfileIconCard";
import css from "./NotificationDropdown.module.css";
const NotificationContent = (props) => {
    const {records, handleOnNotificationClick} = props
    return (
        <div className={css.dropdownScroll}>
        {Array.isArray(records)
            ? records?.map(item => (
                <div className={css.dropdownData} key={item.id} onClick={() => handleOnNotificationClick(item)}>
                    <div className={css.dropDownData}>
                        <div className={css.imageleft}>
                            {item?.actor_image ? (
                                <ResponsiveImage imagewithURL={item?.actor_image} />
                            ) : (
                                <div className={css.nameWrapper}>{abbreviateName(item.actor_name)}</div>
                            )}
                        </div>
                        <div className={css.notificationRight}>
                            <div className={css.notificationText}>
                                {item.notification_text_structure?.map((key, index) => {
                                    const value = item[key];
                                    return value ? (
                                        <span key={index} className={css[key]}>
                                            {value} {' '}
                                        </span>
                                    ) : null;
                                })}
                            </div>
                            <div>
                                {!item?.read_at ? <ProfileIconCard type="green" /> : <ProfileIconCard type="dot_empty" />}
                            </div>
                        </div>
                    </div>
                </div>
            ))
            : null}
    </div>
    )
}

export default NotificationContent